import request from '@/http/request'
import {
  examReportInfo,
  examReportCount,
  pagelist,
  scorePagelist,
  normalData,
  listByCourse,
  getPlanCourse,
  updateAuditState,
  exportPdf,
  normalDataAllCourse,
  examReportAiCheckList,
  examReportAiCheckProgress,
  examReportAiCheckTask
} from '@/http/api'



export const examReportAiCheckTaskAPI = (data) => {
  return request({
      url: examReportAiCheckTask,
      data
  })
}

export const examReportAiCheckProgressAPI = (data) => {
  return request({
      url: examReportAiCheckProgress,
      data
  })
}

export const examReportAiCheckListAPI = (data) => {
  return request({
      url: examReportAiCheckList,
      data
  })
}

export const normalDataAllCourseAPI = (data) => {
  return request({
      url: normalDataAllCourse,
      data
  })
}
export const exportPdfAPI = (data) => {
  return request({
      url: exportPdf,
      data
  })
}
export const getPlanCourseList = (data) => {
  return request({
      url: getPlanCourse,
      data
  })
}
export const listByCourseFN = (data) => {
  return request({
      url: listByCourse,
      data
  })
}
export const getnormalData = (data) => {
  return request({
      url: normalData,
      data
  })
}
export const getScorePagelist = (data) => {
  return request({
      url: scorePagelist,
      data
  })
}
export const examReportInfoFN = (data) => {
    return request({
        url: examReportInfo,
        data
    })
}
export const examReportCountFN = (data) => {
  return request({
      url: examReportCount,
      data
  })
}
export const getPagelist = (data) => {
  return request({
      url: pagelist,
      data
  })
}

